/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularConnectedNoInternet0Bar: {
  name: 'signal-cellular-connected-no-internet-0-bar';
  data: string;
} = {
  name: 'signal-cellular-connected-no-internet-0-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20H18z"/></svg>`
};
